import React from 'react';
import { NavigationButton } from 'web-ui-components/lib/navigation/buttons';
import { Content } from '../../infrastructure/content';

export const ContinueButton = ({ submitButtonText, onClick }) => (
  <Content>
    {({ submitButton }) => (
      <NavigationButton.Primary
        willSubmitForm
        labelText={submitButtonText ? submitButtonText : submitButton}
        onClick={onClick}
      />
    )}
  </Content>
);
